import A11yDialog from 'a11y-dialog';
import { nodeListToArray } from '../helpers/nodeListToArray';
import YouTubeIframeLoader from 'youtube-iframe';
import Player from "@vimeo/player/dist/player.js";
import videojs, { VideoJsPlayer } from 'video.js';

class VideoQueue {
    content;

    push(fn) {
        this.content = fn;
    }

    pop() {
        if (this.content !== null) {
            this.content.call();
            this.content = null;
        }
    }
}

export class VideoModal {
    modal: any;
    modalElement: HTMLElement;
    video?: any;
    videoQueue: VideoQueue;


    constructor(modalElement: HTMLElement, container?: HTMLElement) {
        this.videoQueue = new VideoQueue();
        let args: any = container != null ? { modalElement, container } : modalElement;
        this.modal = new A11yDialog(args);
        this.modalElement = modalElement;
        this.initThumbnail();
        this.modal.on('show', () => {
            document.body.style.overflow = 'hidden';
            this.initVideo();
        });
        this.modal.on('hide', () => {
            document.body.style.overflow = '';
            this.pauseVideo();
        })
    }

    initThumbnail() {
        let video = this.modalElement.querySelector('[data-video-type]');
        if (video) {
            let videoType = video.getAttribute('data-video-type');
            if (videoType == 'brightcove') {
                var brightcoveVideo = this.modalElement.querySelector('[data-video-id]');
                if (brightcoveVideo) {
                    var brightcoveId = brightcoveVideo.getAttribute('data-video-id');
                    if (brightcoveId) {
                        var player = videojs.getPlayer('brightcovePlayer_' + brightcoveId);
                        player.on('loadedmetadata', () => {
                            var image = Array.prototype.slice.call(document.querySelectorAll('[data-brightcove-video]')).filter(i => brightcoveId == i.getAttribute('data-brightcove-video'));
                            if (image) {
                                image[0].setAttribute('src', player.poster());
                            }
                        });
                    }
                }
            }
        }
    }
    initVideo() {
        let video = this.modalElement.querySelector('[data-video-type]');
        if (video) {
            let videoType = video.getAttribute('data-video-type');
            if (videoType == 'vimeo') {
                this.vimeoInit();
            }
            else if (videoType == 'youtube') {
                this.youtubeInit();
            }
            else if (videoType == 'brightcove') {
                this.brightcoveInit();
            }
            else {
                this.nativeVideoInit();
            }
        }
    }

    vimeoInit() {
        let vimeoIframe = this.modalElement.querySelector('iframe');
        if (!vimeoIframe.src) {
            vimeoIframe.src = vimeoIframe.getAttribute('data-src');
            let vimeoPlayer = new Player(vimeoIframe, {});
            vimeoPlayer.on('loaded', this.playVideo.bind(this));
            this.video = vimeoPlayer;
        }
        else {
            this.playVideo();
        }
    }

    youtubeInit() {
        let youtubeIframe = this.modalElement.querySelector('iframe');
        if (!youtubeIframe.src) {
            let uniqueID = this.modalElement.id;

            const initPlayer = (YT) => {
                let playerID = `youtube-player-${uniqueID}`;
                youtubeIframe.id = playerID;
                youtubeIframe.src = youtubeIframe.getAttribute('data-src');
                let youtubePlayer = new YT.Player(playerID, {
                    events: {
                        'onReady': this.onPlayerReady.bind(this)
                    }
                });
                this.video = youtubePlayer;
                this.playVideo();
            };

            if (window['YT'] && window['YT'].Player) {
                initPlayer(window['YT']);
            } else {
                YouTubeIframeLoader.load(initPlayer);
            }
        }
        else {
            this.playVideo();
        }
    }

    nativeVideoInit() {
        let videoElement = this.modalElement.querySelector('video');
        if (videoElement) {
            let videoSource = videoElement.querySelector('source');
            if (!videoSource.src) {
                videoSource.src = videoSource.getAttribute('data-src');
                videoElement.load();
            }
            this.video = videoElement;
        }

        this.playVideo();
    }

    brightcoveInit() {
        var brightcove = this.modalElement.querySelector('[data-video-id]');
        if (brightcove) {
            var brightcoveId = brightcove.getAttribute('data-video-id');
            if (brightcoveId) {
                this.video = videojs.getPlayer('brightcovePlayer_' + brightcoveId);
            }
        }
        var imageSelector = document.querySelector('[data-brightcove-video]');
        if (imageSelector.getAttribute('data-brightcove-video') == this.video.bcinfo.accountId) {
            imageSelector.setAttribute('src', this.video.poster_);
        }
        this.playVideo();
    }

    playVideo() {
        let videoContainer = this.modalElement.querySelector('[data-video-type]');
        if (videoContainer.getAttribute('data-video-type') == 'vimeo') {
            this.video.play();
        }
        else if (videoContainer.getAttribute('data-video-type') == 'youtube') {
            this.playYoutubeVideo(this.video);
        }
        else if (videoContainer.getAttribute('data-video-type') == 'brightcove') {
            this.playBrightcoveVideo(this.video);
        }
        else {
            this.video.play();
        }
    }

    pauseVideo() {
        if (this.modalElement.querySelector('[data-video-type]') && this.video) {
            let videoContainer = this.modalElement.querySelector('[data-video-type]');
            if (videoContainer.getAttribute('data-video-type') == 'vimeo') {
                this.video.pause();
            }
            else if (videoContainer.getAttribute('data-video-type') == 'youtube') {
                this.video.pauseVideo();
            }
            else if (videoContainer.getAttribute('data-video-type') == 'brightcove') {
                this.video.pause();
            }
            else {
                if (!this.video.paused) {
                    this.video.pause();
                }
            }
        }
    }

    onPlayerReady() {
        if (this.videoQueue.content) {
            this.videoQueue.pop();
        }
    }

    isPlayerReady(player) {
        return player && typeof player.playVideo === 'function';
    }

    playYoutubeVideo(player) {
        this.isPlayerReady(player) ? player.playVideo() : this.videoQueue.push(function () {
            player.playVideo();
        });
    }

    playBrightcoveVideo(player) {
        (this.video as VideoJsPlayer).play();
    }
}

export function initializeVideoModals() {
    let videoModals = nodeListToArray(document.querySelectorAll('[data-modal]'));
    videoModals.forEach(videoModal => {
        new VideoModal(videoModal);
    });
}